<template>
  <div>
    <el-form
      ref="settlementForm"
      :model="settlement"
      class="box"
      label-width="100px"
      v-if="settlement != null"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('settlement.title')">{{
            settlement.title
          }}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('settlement.settlerName')">{{
            settlement.settlerName
          }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <fieldset class="mgb15">
      <legend>
        {{ $t("text.lineItem") }}
        <el-button type="default" size="mini" @click="download">
          {{ $t("action.download") }}
        </el-button>
      </legend>
      <vxe-table
        :data="items"
        ref="itemsTable"
        class="recordsTable"
        size="mini"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <s v-if="row.retrieveAt != null">{{ row.serialNo }}</s>

            <span v-if="row.retrieveAt == null">
              <s v-if="row.jyOrderCancelAt != null" class="grey">{{
                row.serialNo
              }}</s>
              <span v-if="row.jyOrderCancelAt == null">{{ row.serialNo }}</span>
            </span>
            <div v-if="row.innerSerialNo != null" class="font10">
              {{ row.innerSerialNo }}
            </div>
            <div>
              <state-label :state="row.workflowState">{{
                $t("mesOrderStates." + row.workflowState)
              }}</state-label>
              <small v-if="row.pauseAt != null" class="orange">
                {{ $t("text.stop") }}
              </small>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="factoryName"
          :title="$t('menu.factories')"
          min-width="80"
        />
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="90"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div class="font10">
              {{ row.terminalCustomerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="90"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
            <div class="font10">
              {{ $t("phase.price") }}:{{ row.costPrice | currency }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="subTotal"
          :title="$t('order.subtotal')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ (row.quantity * row.costPrice) | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('settlement.settleTotal')" min-width="80">
          <template v-slot="{ row }">
            {{ row.factorySettleAmount | currency }}
          </template>
        </vxe-table-column>

        <vxe-table-column :title="$t('text.handle')" min-width="80">
          <template v-slot="{ row }">
            {{ row.ownerName }}
            <div class="font10">{{ row.handleDepart }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column :title="$t('text.remark')" min-width="60">
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="6" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="130"
        >
          <template v-slot="{ row }">
            {{ row.createAt }}
            <div class="font10">
              {{ $t("text.handOverAt2") }}:{{ row.handOverAt }}
            </div>
            <div class="font10">
              {{ $t("action.receive") }}:{{ row.finishedAt }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-if="settlement.settle == false"
          field="action"
          :title="$t('text.action')"
          width="90"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              type="text"
              size="mini"
              @click="editItem(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-button type="text" size="mini" @click="deleteItem(row)">{{
              $t("text.remove")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </fieldset>
    <div class="right pd20">
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
    <!-- 编辑Item -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :visible.sync="editItemDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editItemForm" :model="editItemObj" label-width="80px">
        <el-form-item
          :prop="'factorySettleAmount'"
          :label="$t('settlement.settleTotal')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.settleTotal')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editItemObj.factorySettleAmount"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editItemDoing"
          size="small"
          @click="editItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import Settlement from "@/api/settlement.js";
import OrderMes from "@/api/orderMes.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    Dropzone,
  },
  data() {
    return {
      settlement: { settle: false },
      items: [],
      // 编辑Item
      editItemDF: false,
      editItemObj: {
        factorySettleAmount: null,
      },
      row: null,
      rowIndex: null,
      editItemDoing: false,
    };
  },
  watch: {
    id() {
      this.getSettlement();
    },
  },
  created() {
    const self = this;
    self.loadingStart();
    Settlement.findByIdMes(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.settlement = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
      self.getItems();
    });
  },
  methods: {
    download() {
      const self = this;
      OrderMes.exportExcelByFactorySettlementId(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 移除
    deleteItem(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRemove"))) {
        OrderMes.clearSettle(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getSettlement();
            self.$emit("updateData");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑账单明细
    editItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.editItemObj.factorySettleAmount = row.factorySettleAmount;
      self.editItemObj.uuid = row.uuid;
      self.editItemDoing = false;
      self.editItemDF = true;
    },

    editItemSubmit() {
      const self = this;
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editItemObj.factorySettleAmount)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("settlement.settleTotal"),
              ]),
              type: "warning",
            });
            return;
          }
          self.editItemDoing = true;
          OrderMes.updateFactorySettlement(self.row.id, self.editItemObj).then(
            function (res) {
              self.editItemDoing = false;
              self.editItemDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.items[self.rowIndex].factorySettleAmount =
                self.editItemObj.factorySettleAmount;
              // self.getSettlement();
              self.$emit("updateData");
            }
          );
        } else {
          return false;
        }
      });
    },
    getSettlement() {
      const self = this;
      Settlement.findByIdMes(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.settlement = res.data.entity;
          self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    getItems() {
      const self = this;
      OrderMes.findBySettlementId(self.id).then(function (res) {
        if (res.status === 200) {
          self.items = res.data;
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
